import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import {
  PlanAccount,
  CreatePlanAccountRequest,
  UpdatePlanAccountRequest,
  ListPlanAccountsQuery,
  PlanAccountImportCreateRequest,
} from './PlanAccounts.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/planAccounts`;

export async function listPlanAccounts(
  params?: PageRequest,
): Promise<PageResult<PlanAccount>> {
  const result = (await api.get(`${CONTROLLER_URL}/filter`, params)) as unknown;

  return result as PageResult<PlanAccount>;
}

export async function listPlanAccountsAll(
  params?: PageRequest,
): Promise<PageResult<PlanAccount>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/filter/all`,
    params,
  )) as unknown;

  return result as PageResult<PlanAccount>;
}

export async function getPlanAccount(id: number): Promise<PlanAccount> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as PlanAccount;
}

export async function createPlanAccount(
  obj: CreatePlanAccountRequest,
): Promise<PlanAccount> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as PlanAccount;
}

export async function updatePlanAccount(
  obj: UpdatePlanAccountRequest,
): Promise<PlanAccount> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as PlanAccount;
}

export async function deletePlanAccount(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function activateOrInactivatePlanAccount(planAccountId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${planAccountId}/active`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function lastPlanAccount(
  params: ListPlanAccountsQuery,
): Promise<PlanAccount> {
  const result = (await api.get(`${CONTROLLER_URL}/last`, params)) as unknown;

  return result as PlanAccount;
}

export async function createListPlanAccount(
  params: PlanAccountImportCreateRequest,
) {
  const result = (await api.post(`${CONTROLLER_URL}/list`, params)) as unknown;

  return result;
}
